import * as ReactDOMClient from 'react-dom/client';
import InsyncPharmacyView from './InsyncPharmacyView'
import './i18n';

var mountNode = document.getElementById("app");

const root = ReactDOMClient.createRoot(mountNode);
root.render(<InsyncPharmacyView/>)